var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-nav"},[_c('el-menu',{ref:"menu",attrs:{"default-active":_vm.menuId,"default-openeds":_vm.openeds,"background-color":"#2b2e3b","text-color":"#ccc","active-text-color":"#fff"}},[_vm._l((_vm.data),function(item){return [(item.isShow==1)?_c('sub-menu',{key:item.id,attrs:{"data":item}}):_vm._e()]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd72f4f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/menu.vue
// module id = null
// module chunks = 